"use client";

import "./EmptyVideoCard.css";

interface EmptyVideoCardProps {
  title?: string;
  subtitle?: string;
  icon?: React.ReactNode;
  className?: string;
}

const EmptyVideoCard = ({
  title = "This video isn't here right now.",
  subtitle = "It may be waiting to bless someone later — or it's on its way to return.",
  icon = "📼",
  className = "",
}: EmptyVideoCardProps) => {
  return (
    <div className={`empty-video-card ${className}`}>
      <div className="empty-video-icon">{icon}</div>
      <p className="empty-video-title">{title}</p>
      <p className="empty-video-subtitle">{subtitle}</p>
    </div>
  );
};

export default EmptyVideoCard;